import { SeoRenderer } from "../../../common/helpers/seo";

import loadableComponent from "./loadable";

export default {
    component: loadableComponent,
    renderSeo: (store: any, allMessage: {[key: string]: string}, lang: string) => {
        SeoRenderer({
            title: allMessage["help.moderation.title"],
            description: allMessage["help.moderation.description"],
            allMessage,
            lang,
        });
    },
};
